import methods from '../methods'

export const matchLogout = () => ({
    type: methods.LOGOUT
})

export const switchPage = page => ({
    type: methods.SWITCH_PAGE,
    payload: page
})

export const updateProfile = profile => ({
    type: methods.UPDATE_PROFILE,
    payload: profile
})

export const updateHugs = hugs => ({
    type: methods.UPDATE_HUGS,
    payload: hugs
})

export const updateSupportMessages = msgs => ({
    type: methods.UPDATE_MSGS,
    payload: msgs
})

export const updateMatches = matches => ({
    type: methods.UPDATE_MATCHES,
    payload: matches
})

export const updateConnectedUsers = users => dispatch => {
    
    dispatch({
        type: methods.UPDATE_CONNECT_USERS,
        payload: users
    })
}

export const loopConnectedUsers = users => dispatch => {
    console.log("test loop user")
    let contactIdJson = {}, senderIdJson = {}, receiverIdJson = {}
    users.map((item, idx) => {
        console.log(item)
        if(item?.sender_id) senderIdJson[item?.sender_id] = item
        if(item?.contact_id) contactIdJson[item?.contact_id] = item
        if(item?.reciever_id) receiverIdJson[item?.reciever_id] = item
    })
    dispatch({
        type: methods.LOOP_CONNECT_USERS_SENDER_ID,
        payload: senderIdJson
    })
    dispatch({
        type: methods.LOOP_CONNECT_USERS_RECEIVER_ID,
        payload: receiverIdJson
    })
    dispatch({
        type: methods.LOOP_CONNECT_USERS,
        payload: contactIdJson
    })
}